"use client";
import { useRouter } from "next/navigation";
import { c } from "@/lib/vster/theme";

// /weekly 상단 캠페인(제목) 선택 — 최근 3개월 큐레이션 캠페인 중 하나를 골라 그 편을 본다.
//   선택 시 /weekly?c={id} 로 이동(서버에서 해당 캠페인 렌더). 최신(=첫 항목)이면 ?c 없이 /weekly.
export default function WeeklyCampaignSelect({
  campaigns, selectedId, latestId,
}: {
  campaigns: { id: number; title: string; date: string }[];
  selectedId: number;
  latestId: number;
}) {
  const router = useRouter();
  if (campaigns.length <= 1) return null;
  return (
    <label style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <span style={{ fontSize: 12.5, fontWeight: 700, color: "rgba(255,255,255,.8)" }}>지난 추천 보기</span>
      <select
        value={selectedId}
        onChange={(e) => {
          const id = Number(e.target.value);
          router.push(id === latestId ? "/weekly" : `/weekly?c=${id}`);
        }}
        style={{
          appearance: "none", background: "#fff", color: c.ink, border: "none",
          borderRadius: 10, padding: "8px 32px 8px 14px", fontSize: 14, fontWeight: 700,
          cursor: "pointer", maxWidth: 340, textOverflow: "ellipsis",
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%232C5CFF' stroke-width='3'><path d='M6 9l6 6 6-6'/></svg>\")",
          backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center",
        }}
      >
        {campaigns.map((m) => (
          <option key={m.id} value={m.id}>{m.title}{m.date ? ` (${m.date})` : ""}</option>
        ))}
      </select>
    </label>
  );
}
